import { Injectable, OnDestroy } from '@angular/core';
import { IOneIDConfig } from '../interfaces/iOneIDConfig';


@Injectable({
  providedIn: 'root',
})


export class OneIDConfigService {

  oneIDConfig: string;
  url: string;

  configuration: IOneIDConfig = {
    brands: {
      dcl: {
        allowedLocales: { en: 'en-us' },
        name: 'Disney Cruise Line',
        defaultLocaleCookieProperty: 'preferredRegion',
        baseURL: 'https://disneycruise.disney.go.com',
        oneId: {
          clientId: "TPR-DCL-LBJS.WEB-",
          promotionId: "LeadGen",
          marketingCodes: ["disCruiseLine"],
        },
      }
    },
    environmentConfiguration: {
      stage: {
          oneIdEnv: 'STAGE',
          oneIdLibraryUrlPrefix: 'stg.cdn',
          oneIdProfileLibraryUrlPrefix: 'stage.cdn1'
      },
      lt01: {
          oneIdEnv: 'VALID',
          oneIdLibraryUrlPrefix: 'ui-val',
          usingOneIdProfileLibrary: ['dcl']
        },
      prod: {
          oneIdEnv: 'PROD',
          oneIdLibraryUrlPrefix: 'cdn',
          oneIdProfileLibraryUrlPrefix: 'cdn1',
          usingOneIdProfileLibrary: ['dcl']
        }
      }
    };

  constructor() {
    this.url = window.location.href;
    this.getEnvFromUrl();
  }

  getEnvFromUrl() {
    if ( this.url.includes('latest') || this.url.includes('stage') || this.url.includes('localhost')) {
      return this.configuration.environmentConfiguration.stage;
    }
    if ( this.url.includes('valid')) {
      return this.configuration.environmentConfiguration.lt01;
    }

    return this.configuration.environmentConfiguration.prod;
  }
}
